import type { LangType } from "@/interface/common.interface";

export const ARENA_TOKEN = "arena_token";
export const DEFAULT_CURRENCY =
  localStorage.getItem("defaultCurrency") || "PHP";
export const DEFAULT_TIME_ZONE = localStorage.getItem("timezone");
export const DEFAULT_LANG = (localStorage
  .getItem("umi_locale")
  ?.split("-")
  ?.join("_") || "zh_CN") as LangType;

export const STATUS = {
  ENABLE: "enable",
  DISABLE: "disable",
};


// 站点配置相关常量
export interface SiteConfig {
  siteNation: string;
  countryCode: string;
  countryName: string;
  currencyCode?: string;
}

export const SITE_MAP: Record<string, SiteConfig> = {
  Philippines: {
    siteNation: "Philippines",
    countryCode: "+63",
    countryName: "菲律宾",
    currencyCode: "PHP",
  },
  Nigeria: {
    siteNation: "Nigeria",
    countryCode: "+234",
    countryName: "尼日利亚",
    currencyCode: "NGN",
  },
  // P1921 Slotupia（play.slotupia.com），币种 NGN，时区尼日利亚 UTC+1
  Slotupia: {
    siteNation: "Slotupia",
    countryCode: "+243",
    countryName: "Slotupia",
    currencyCode: "NGN",
  },
};

// 获取当前激活的站点配置
export const CURRENT_SITE_CONFIG =
  SITE_MAP[process.env.SITE_ENV || "Philippines"];
